module.exports = __webpack_public_path__ + "static/img/cont34 (6).926522f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont34 (6).jpg
// module id = lGoP
// module chunks = 0